import React from 'react';
import './Settings.css';

export default function Settings() {
  return (
    <div className="settings-container">
      <div className="page-header">
        <h1>Settings</h1>
        <p>Configure your application preferences</p>
      </div>
      
      <div className="page-content">
        <p>This page is under construction. Settings and configuration options will be implemented here.</p>
      </div>
    </div>
  );
}
